import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createGeneralPhysicalAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface GeneralPhysicalAssessmentResult {
  id: string;
  assessmentType: 'physical';
  scores: {
    overall: number;
    categories: {
      name: string;
      score: number;
      description: string;
    }[];
  };
  results: {
    level: 'Low' | 'Moderate' | 'High' | 'Completed';
    interpretation: string;
    recommendations?: any[];
  };
  createdAt: string;
  physicalData?: {
    dateOfBirth?: string;
    age?: number;
    gender?: string;
    height?: number;
    heightCm?: number;
    heightFeet?: number;
    heightInches?: number;
    weight?: number;
    weightKg?: number;
    weightPounds?: number;
    chronicConditions?: boolean;
  };
  responses?: any[];
}

const GeneralPhysicalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as GeneralPhysicalAssessmentResult;

  // Handle navigation in useEffect to avoid calling navigate during render
  useEffect(() => {
    if (!assessmentResult) {
      // If no result data, redirect to learn page
      navigate('/panel/learn/');
      return;
    }
  }, [assessmentResult, navigate]);

  // Don't render anything if no assessment result
  if (!assessmentResult) {
    return null;
  }

  // Create configuration using the template system
  const config = createGeneralPhysicalAssessmentConfig(assessmentResult);

  // Use the template component
  return <AssessmentCompletionTemplate config={config} />;
};

export default GeneralPhysicalAssessmentCompletionPage;


